import React from 'react';
import { useTranslation } from 'react-i18next';
import connect from 'react-redux/es/connect/connect';

import { Icon, Label, Table, Popup } from 'semantic-ui-react';

const ContactListCell = ({ rowValues, entryRecord, index, showPersonalData }) => {
  const { t } = useTranslation();
  let contacts = [];
  const componentKey = rowValues.ID + index;
  const rowValue = rowValues[entryRecord.key];
  const atCernArray = rowValues['GEN_CONTACTS_ATCERN']?.split(',');

  const atCernByName = {};

  atCernArray?.forEach(entry => {
    const [key, value] = entry.split(":");
    atCernByName[key] = value;
  });


  const getNotPresentAtCernWarning = contact => {
    if (!atCernArray || atCernArray.length === 0) {
      return <></>;
    }
    return (
        atCernByName[contact] === 'N' && (
        <Popup
          trigger={<Icon name="warning sign" className="warningIconNotAtCern" />}
          on={['hover']}
          size="mini"
          content={t('message.person.not.present.at.cern')}
        />
      )
    );
  };
  if (rowValue !== 'null' && typeof rowValue !== 'undefined') {
    rowValue.split(/\n|,/).forEach(contact => {
      contacts.push(
        <Label
          basic
          style={{ fontWeight: 'normal' }}
          key={'contact_label_' + componentKey + contact}
        >
          {getNotPresentAtCernWarning(contact)}
          <Icon name="user outline" key={'contact_label_' + componentKey + contact} />
          {showPersonalData ? contact : contact.replace(/[a-z]/g, 'x')}
        </Label>
      );
    });
  }

  return (
    <Table.Cell key={rowValues.ID + index} className="tableCell tableCellReducedPadding2">
      {rowValue !== 'null' && contacts}
    </Table.Cell>
  );
};

const mapStateToProps = state => ({
  showPersonalData: state.dataPrivacy.showPersonalData,
});

export default connect(mapStateToProps, null)(ContactListCell);
